<div [ngClass]="{'backBackground' : auth.currentUserIDSig()?.uid !== null}">
  <div class="transitionEffectAll600 roundedCorner"
    [ngClass]="{'mainZero' : auth.currentUserIDSig()?.uid === null, 'mainMax' : sb.currentSidebarSize() === 'max' && auth.currentUserIDSig()?.uid !== null,'mainMin' : sb.currentSidebarSize() === 'min' && auth.currentUserIDSig()?.uid !== null}"
    *transloco="let t">
    <div class="page-content container-fluid base-font-color">
      <div class="row">
        <div class="col p-0 p-md-1">
          @if (auth.currentUserIDSig()?.uid !== null) {
          @if(showSpinner || !this.auth.currentLangSig()?.lang) {
          <div class="row">
            <div class="col">
              <span class="placeholder-glow">
                <span class="placeholder placeholder-lg col-4"></span>
              </span>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col text-center">
              <div class="svl-ripple">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
          }
          @if(!showSpinner && this.auth.currentLangSig()?.lang) {
          <div class="page-header base-font-color">
            <h2>{{t('profile.profile-settings')}}</h2>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-12 order-lg-1 order-md-1 my-3">
              <div class="card">
                @if (!this.auth.currentLangSig()?.lang) {
                <div class="card-header bg-white">
                  <p class="fs-5 card-text placeholder-glow">
                    <span class="placeholder col-6"></span>
                    <span class="placeholder col-4 bg-white"></span>
                    <span class="placeholder col-2 bg-danger"></span>
                  </p>
                </div>
                }
                @if (this.auth.currentLangSig()?.lang) {
                <div class="card-header bg-white shadow-sm d-flex justify-content-between">
                  <h5 class="card-title m-0 align-self-center base-font-color">{{t('profile.personal-details')}}</h5>
                  @if (this.EditMode !== 'personal') {
                  <span class="material-symbols-outlined method-button method-blue pt-1" style="height: 31px;"
                    role="button" tabindex="0" data-bs-toggle="modal" data-bs-target="#updateUserModal">
                    edit
                  </span>
                  }
                </div>
                }
                <div class="card-body">

                  <div class="card-text mb-2 base-font-color">
                    <div class="row">
                      <div class="col ps-3 text-uppercase">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <div class="placeholder-glow">
                          <span class="placeholder col-3 bg-dark"></span>
                        </div>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <small>{{t('profile.list-name')}}</small>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <div class="col ps-3">
                        @if (!this.db.currentUserDataSig()?.name) {
                        <p class="placeholder-glow mb-0">
                          <span class="placeholder col-6 bg-light"></span>
                        </p>
                        }
                        @if (this.db.currentUserDataSig()?.name) {
                        <strong>{{this.db.currentUserDataSig()?.name | slice:0:45}}</strong>
                        }
                      </div>
                    </div>
                  </div>
          <button (click)="runFillMissingHashes()">
            Uruchom uzupełnianie hashy
          </button>
          <button (click)="runFixAmounts()">
            Uruchom fixowanie amount
          </button>
                  <div class="card-text mb-2 base-font-color">
                    <div class="row">
                      <div class="col ps-3 text-uppercase">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <div class="placeholder-glow">
                          <span class="placeholder col-3 bg-dark"></span>
                        </div>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <small>{{t('profile.list-surname')}}</small>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <div class="col ps-3">
                        @if (!this.db.currentUserDataSig()?.surname) {
                        <p class="placeholder-glow mb-0">
                          <span class="placeholder col-6 bg-light"></span>
                        </p>
                        }
                        @if (this.db.currentUserDataSig()?.surname) {
                        <strong>{{this.db.currentUserDataSig()?.surname | slice:0:45}}</strong>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="card-text mb-2 base-font-color">
                    <div class="row">
                      <div class="col ps-3 text-uppercase">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <div class="placeholder-glow">
                          <span class="placeholder col-3 bg-dark"></span>
                        </div>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <small>{{t('profile.list-username')}}</small>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <div class="col ps-3">
                        @if (!this.db.currentUserDataSig()?.username) {
                        <p class="placeholder-glow mb-0">
                          <span class="placeholder col-6 bg-light"></span>
                        </p>
                        }
                        @if (this.db.currentUserDataSig()?.username) {
                        <strong>{{this.db.currentUserDataSig()?.username | slice:0:45}}</strong>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="card-text mb-2 base-font-color">
                    <div class="row">
                      <div class="col ps-3 text-uppercase">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <div class="placeholder-glow">
                          <span class="placeholder col-3 bg-dark"></span>
                        </div>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <small>{{t('profile.list-email')}}</small>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <div class="col ps-3">
                        @if (!this.db.currentUserDataSig()?.email) {
                        <p class="placeholder-glow mb-0">
                          <span class="placeholder col-6 bg-light"></span>
                        </p>
                        }
                        @if (this.db.currentUserDataSig()?.email) {
                        <strong>{{this.db.currentUserDataSig()?.email | slice:0:45}}</strong>
                        }
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>


            <div class="col-xl-6 col-lg-6 col-md-12 order-lg-2 order-md-2 my-3">
              <div class="card">
                @if (!this.auth.currentLangSig()?.lang) {
                <div class="card-header bg-white">
                  <p class="fs-5 card-text placeholder-glow">
                    <span class="placeholder col-6"></span>
                    <span class="placeholder col-4 bg-white"></span>
                    <span class="placeholder col-2 bg-danger"></span>
                  </p>
                </div>
                }

                @if (this.auth.currentLangSig()?.lang) {
                <div class="card-header bg-white shadow-sm d-flex justify-content-between">
                  <h5 class="card-title m-0 align-self-center">{{t('profile.savologic-details')}}</h5>
                  @if (this.EditMode != 'savout') {
                  <span class="material-symbols-outlined method-button method-blue pt-1" style="height: 31px;"
                    role="button" tabindex="0" data-bs-toggle="modal" data-bs-target="#updateAccountModal">
                    edit
                  </span>
                  }
                </div>
                }
                <div class="card-body">
                  <div class="card-text mb-2 base-font-color">
                    <div class="row">
                      <div class="col ps-3 text-uppercase">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <div class="placeholder-glow">
                          <span class="placeholder col-3 bg-dark"></span>
                        </div>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <small>{{t('profile.list-language')}}</small>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <div class="col ps-3 text-uppercase">
                        @if (!this.db.currentUserDataSig()?.lang) {
                        <p class="placeholder-glow mb-0">
                          <span class="placeholder col-6 bg-light"></span>
                        </p>
                        }
                        @if (this.db.currentUserDataSig()?.lang) {
                        <strong>{{this.db.currentUserDataSig()?.lang}}</strong>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="card-text mb-2 base-font-color">
                    <div class="row">
                      <div class="col ps-3 text-uppercase">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <div class="placeholder-glow">
                          <span class="placeholder col-3 bg-dark"></span>
                        </div>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <small>{{t('profile.list-currency')}}</small>
                        }

                      </div>
                    </div>
                    <div class="row">
                      <div class="col ps-3 text-uppercase">
                        @if (!this.db.currentUserDataSig()?.currency) {
                        <p class="placeholder-glow mb-0">
                          <span class="placeholder col-6 bg-light"></span>
                        </p>
                        }
                        @if (this.db.currentUserDataSig()?.currency) {
                        <strong>{{this.db.currentUserDataSig()?.currency}}</strong>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="card-text mb-2 base-font-color">
                    <div class="row">
                      <div class="col ps-3 text-uppercase">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <div class="placeholder-glow">
                          <span class="placeholder col-3 bg-dark"></span>
                        </div>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <small>{{t('profile.list-reg-date')}}</small>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <div class="col ps-3 text-uppercase">
                        @if (!this.db.currentUserDataSig()?.regDate) {
                        <p class="placeholder-glow mb-0">
                          <span class="placeholder col-6 bg-light"></span>
                        </p>
                        }
                        @if (this.db.currentUserDataSig()?.regDate) {
                        <strong>{{this.db.currentUserDataSig()?.regDate}}</strong>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="card-text mb-2 base-font-color">
                    <div class="row">
                      <div class="col ps-3 text-uppercase">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <div class="placeholder-glow">
                          <span class="placeholder col-3 bg-dark"></span>
                        </div>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <small>{{t('profile.list-plan')}}</small>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <div class="col ps-3 text-uppercase">
                        @if (!this.db.currentUserDataSig()?.plan) {
                        <p class="placeholder-glow mb-0">
                          <span class="placeholder col-6 bg-light"></span>
                        </p>
                        }
                        @if (this.db.currentUserDataSig()?.plan) {
                        <strong>{{this.db.currentUserDataSig()?.plan}}</strong>
                        }
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>

          <!-- SEGMENT METODY PŁATNOŚCI -->
          <div class="page-header base-font-color mt-3">
            @if (!this.auth.currentLangSig()?.lang) {
            <p class="placeholder-glow">
              <span class="placeholder placeholder-lg col-3"></span>
            </p>
            }
            @if (this.auth.currentLangSig()?.lang) {
            <h2>{{t('profile.profile-payment-methods')}}</h2>
            }
          </div>
          <div class="row" id="dynamicPaymentGenerator">
            <div class="col-xl-6 col-lg-6 col-md-12" [ngClass]="{'d-none' : method.key == 'default'}"
              *ngFor="let method of this.db.currentPaymentMethodsSig() | keyvalue:sortByValueAsc; index as methodIndex;">
              <div class="card my-3">
                @if (!this.auth.currentLangSig().lang || !method.value) {
                <div class="card-header bg-white">
                  <p class="fs-5 card-text placeholder-glow">
                    <span class="placeholder col-8"></span>
                    <span class="placeholder col-4 bg-white"></span>
                  </p>
                </div>
                }
                @if (this.auth.currentLangSig().lang && method.value)
                {
                <div class="card-header bg-white shadow-sm">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-content-center" style="height: 31px;">
                      <span class="material-symbols-outlined mt-1 me-2">
                        @if(methodIndex === 1) {
                        credit_card
                        }
                        @if(methodIndex > 1) {
                        payments
                        }
                      </span>
                      <h5 class="card-title mt-1">
                        {{method.value['name']}}</h5>
                    </div>
                    <span class="material-symbols-outlined mt-1 me-2 method-button method-blue" data-bs-toggle="modal"
                      data-bs-target="#paymentMethodsModal"
                      (click)="this.valuesPasser(methodIndex.toString(),'0',method.value['name'])"
                      title="{{t('profile.icon-rename-method-title')}}">edit</span>
                  </div>
                </div>
                }
                <div class="card-body">
                  <div class="row">
                    <div class="col-xl-6 col-lg-12 col-md-6 col-sm-6 col-xs-1"
                      *ngFor="let source of method.value | keyvalue:sortByValueAsc; index as sourceIndex;"
                      [ngClass]="{'d-none' : source.key == 'name' || source.value['name'] == this.auth.currentUserIDSig()?.uid}">
                      @if(this.sourcesSpinner) {
                      <div class="alert border alert-white shadow-sm">
                        <p class="placeholder-glow mt-3">
                          <span class="placeholder col-12 placeholder-lg"></span>
                        </p>
                      </div>
                      }
                      @if(!this.sourcesSpinner) {
                      <div class="alert border alert-white shadow-sm d-flex">
                        <div class="col d-flex align-items-center ">
                          <span class="material-symbols-outlined method-button me-2">
                            counter_{{sourceIndex}}
                          </span>
                          <div class="align-self-center">
                            {{source.value['name']}}
                          </div>
                        </div>
                        <div class="vstack gap-1 method-button align-items-end">
                          @if (this.db.currentPaymentMethodsSig().default ==
                          getKeySuffix(method.key).concat(".".concat(source.key.substring(6)))) {
                          <span class="material-symbols-outlined method-button source-verified"
                            title="{{t('profile.icon-default-method-title')}}">
                            verified
                          </span>
                          }
                          @if (this.db.currentPaymentMethodsSig().default !=
                          getKeySuffix(method.key).concat(".".concat(source.key.substring(6)))) {

                          <span title="{{t('profile.icon-make-default-source-title')}}"
                            (click)="this.updatePaymentMethods(getKeySuffix(method.key), source.key.substring(6),'setDefault', this.auth.currentUserIDSig()?.uid); this.triggerSpinner(true);"
                            class="material-symbols-outlined method-button method-green">
                            check_box_outline_blank
                          </span>
                          }

                          <span class="material-symbols-outlined method-button method-blue"
                            title="{{t('profile.icon-rename-source-title')}}" data-bs-toggle="modal"
                            data-bs-target="#paymentMethodsModal"
                            (click)="this.valuesPasser(getKeySuffix(method.key), source.key.substring(6),source.value['name'])">
                            edit
                          </span>
                          <span class="material-symbols-outlined method-button method-red"
                            title="{{t('profile.icon-delete-source-title')}}" data-bs-toggle="modal"
                            data-bs-target="#deletionModal"
                            (click)="this.valuesPasser(getKeySuffix(method.key), source.key.substring(6),source.value['name'])">
                            delete
                          </span>
                        </div>

                      </div>
                      }
                    </div>

                    <div class="col-xl-6 col-lg-12 col-md-6 col-sm-6 col-xs-1 align-self-center"
                      *ngFor="let source of method.value | keyvalue:sortByValueAsc; index as sourceIndex;"
                      [ngClass]="{'d-none' : source.value['name'] != this.auth.currentUserIDSig()?.uid}">
                      <div class="alert alert-white border-dashed d-flex">
                        <div class="col text-center align-self-center">
                          <span class="material-symbols-outlined mt-1 method-button method-blue"
                            title="createnew source"
                            (click)="this.updatePaymentMethods(getKeySuffix(method.key), sourceIndex.toString(),'createSource', this.auth.currentUserIDSig()?.uid);">
                            add_circle
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
          <!-- SEGMENT METODY PŁATNOŚCI -->
          }
          @if (auth.currentUserIDSig()?.uid == null) {

          <div class="container mt-5" *transloco="let t">
            <div class="row">
              <div class="col-lg-6 d-none d-lg-block text-center my-auto">
                <img src="assets/home/home_devices.svg" class="whyImage">
              </div>
              <div class="col-lg-6 col">


                @if (LoginMode) {
                <div class="row">
                  <div class="col-xl-2 col-lg-none col-md-none"></div>
                  <div class="col-xl-8 col-lg-12 pt-5">
                    <div class="loginBox bgc-light-grey" *ngIf="this.LoginMode">
                      <div class="pb-2" style="text-align: center;">
                        <p class="display-6">{{t('profile.signin-header')}}</p>

                      </div>
                      <div class="borderGrey bgc-white shadow-sm rounded p-5">
                        @if (this.errorMessage != null) {
                        <div class="alert alert-danger" role="alert">
                          {{errorMessage}}
                        </div>

                        }
                        <form #LogInForm="ngForm" autocomplete="off" (ngSubmit)="onSubmit(LogModel, 'log')">
                          <div class="input-group input-group-sm mb-3">
                            <input [(ngModel)]="LogModel.email" name="email" type="email" #email="ngModel"
                              class="form-control" [attr.placeholder]="t('profile.signin-email')" required>
                          </div>
                          <div class="input-group input-group-sm mb-3">
                            <input [(ngModel)]="LogModel.password" #password="ngModel" name="password" type="password"
                              class="form-control" [attr.placeholder]="t('profile.signin-password')" required>
                          </div>
                          <div class="text-center">
                            <button class="btn btn-primary rounded-pill" [class.disabled]="LogInForm.invalid">
                              {{t('profile.signin-button')}}
                            </button>
                          </div>
                        </form>
                        <div class="text-center mt-2">
                          <button class="btn btn-link"
                            (click)="this.LoginMode = false; this.RegisterMode = false; this.ResetPasswordMode = true; this.CheckEmailMode = false;">
                            <span class="small">{{t('profile.password-reset')}}</span>

                          </button>
                        </div>
                      </div>

                      <div class="borderGrey bgc-white shadow-sm rounded mt-3 p-3">
                        <div class="row text-center">
                          <div class="col">{{t('profile.no-account')}}
                            <br>
                            <span
                              (click)="this.LoginMode = false; this.RegisterMode = true; this.ResetPasswordMode = false; this.CheckEmailMode = false;"
                              class="text-info cursor-pointer">{{t('profile.signup-header')}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-none col-md-none"></div>
                </div>
                }
                @if (RegisterMode) {

                <div class="row">


                  <div class="col-xl-2 col-lg-none col-md-none"></div>
                  <div class="col-xl-8 col-lg-12 pt-5">
                    <div class="loginBox bgc-light-grey" *ngIf="this.RegisterMode">
                      <div class="pb-2" style="text-align: center;">
                        <p class="display-6">{{t('profile.signup-header')}}</p>

                      </div>
                      <div class="borderGrey bgc-white shadow-sm rounded p-5">
                        @if (this.errorMessage != null) {
                        <div class="alert alert-danger" role="alert">
                          {{errorMessage}}
                        </div>

                        }
                        <form #RegistrationForm="ngForm" (ngSubmit)="onSubmit(RegModel, 'reg')">
                          <div class="container">
                            @if(errorMessage) {
                            <div>{{errorMessage}}</div>
                            }
                            <div class="input-group input-group-sm mb-3">
                              <input [(ngModel)]="RegModel.username" #username="ngModel" name="username" type="text"
                                class="form-control" [attr.placeholder]="t('profile.signup-username')" required>
                            </div>

                            <div class="input-group input-group-sm mb-3">
                              <input [(ngModel)]="RegModel.email" name="email" type="email" #email="ngModel"
                                class="form-control" [attr.placeholder]="t('profile.signup-email')" required>
                            </div>
                            <div class="input-group input-group-sm mb-3">
                              <input [(ngModel)]="RegModel.password" #password="ngModel" name="password" type="password"
                                class="form-control" [attr.placeholder]="t('profile.signup-password')" required>

                            </div>


                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" id="lang_pl" value="pl" name="lang"
                                [(ngModel)]="RegModel.lang">
                              <label class="form-check-label" for="lang_pl">Polski</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" id="lang_en" value="en" name="lang"
                                [(ngModel)]="RegModel.lang">
                              <label class="form-check-label" for="lang_en">English</label>
                            </div>

                            <hr class="light">


                            <div class="text-center">
                              <button [class.disabled]='RegistrationForm.invalid'
                                class="btn btn-primary rounded-pill col-8 mx-auto">
                                {{t('profile.signup-button')}}
                              </button>
                            </div>
                          </div>
                        </form>

                      </div>

                      <div class="borderGrey bgc-white shadow-sm rounded mt-3 p-3">
                        <div class="row text-center">
                          <div class="col">{{t('profile.account')}}
                            <br>
                            <span (click)="this.LoginMode = true; this.RegisterMode = false;"
                              class="text-info cursor-pointer">{{t('profile.signin-header')}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-none col-md-none"></div>
                </div>

                }

                @if(ResetPasswordMode) {
                <div class="row">
                  <div class="col-xl-2 col-lg-none col-md-none"></div>
                  <div class="col-xl-8 col-lg-12 pt-5">
                    <div class="loginBox bgc-light-grey">
                      <div class="pb-2" style="text-align: center;">
                        <p class="display-6">{{t('profile.reset-title')}}</p>
                      </div>
                      <div class="borderGrey bgc-white shadow-sm rounded p-5">
                        @if (this.errorMessage != null) {
                        <div class="alert alert-danger" role="alert">
                          {{errorMessage}}
                        </div>

                        }
                        <form #ResetPasswordForm="ngForm" autocomplete="off"
                          (ngSubmit)="onSubmit(ResetPasswordModel, 'resetPassword')">
                          <div class="input-group input-group-sm mb-3">
                            <input [(ngModel)]="ResetPasswordModel.email" name="email" type="email" #email="ngModel"
                              class="form-control" [attr.placeholder]="t('profile.signin-email')" required>
                          </div>
                          <div class="text-center">
                            <button class="btn btn-primary rounded-pill" [class.disabled]="ResetPasswordForm.invalid">
                              {{t('general.button-reset')}}
                            </button>
                          </div>
                        </form>
                      </div>
                      <div class="borderGrey bgc-white shadow-sm rounded mt-3 p-3">
                        <div class="row text-center">
                          <div class="col">{{t('profile.no-account')}}
                            <br>
                            <span
                              (click)="this.LoginMode = false; this.RegisterMode = true; this.ResetPasswordMode = false; this.CheckEmailMode = false;"
                              class="text-info cursor-pointer">{{t('profile.signup-header')}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-none col-md-none"></div>
                </div>
                }
                @if(CheckEmailMode) {
                <div class="row">
                  <div class="col-xl-2 col-lg-none col-md-none"></div>
                  <div class="col-xl-8 col-lg-12 pt-5">
                    <div class="loginBox bgc-light-grey">
                      <div class="pb-2" style="text-align: center;">
                        <p class="display-6">{{t('profile.reset-title')}}</p>
                      </div>
                      <div class="borderGrey bgc-white shadow-sm rounded p-5 text-center">
                        <p>{{t('profile.reset-password-summary')}}</p>
                        <button class="btn-blue"
                          (click)="this.LoginMode = true; this.RegisterMode = false; this.ResetPasswordMode = false; this.CheckEmailMode = false;">
                          {{t('profile.signin-button')}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-none col-md-none"></div>
                </div>
                }

              </div>
            </div>
          </div>

          }
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center pt-3">
      <p class="fw-lighter"><span>SAVO</span><span class="text-info-emphasis">LOGIC</span> {{appVersion}}</p>
    </div>
  </div>
</div>




<!-- RENAME MODAL -->
<div class="modal fade" id="paymentMethodsModal" tabindex="-1" aria-labelledby="deletionModalLabel" aria-hidden="true"
  *transloco="let t">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col text-end">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              title="{{t('general.button-close')}}"></button>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            <span class="material-symbols-outlined modal-icon-grey align-content-center">
              draw
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col text-center">
            <i>{{this.paymentMethodsDetails[2]}}</i>
            <div class="my-3 text-center">
              <h5>{{t('profile.new-name')}}</h5>
              <form #renamePaymentMethods="ngForm">
                <input type="text" class="form-control" required [class.is-invalid]="newName.invalid && newName.touched"
                  [(ngModel)]="paymentMethodsModel.name" #newName="ngModel" name="newName"
                  placeholder="{{paymentMethodsModel.name}}">
                <div class="invalid-feedback">{{t('general.form-feedback')}}</div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer px-0">
        <div class="container-fluid">
          <div class="row">
            <div class="col-4 d-grid">
              <button class="btn btn-sm btn-link btn-link-secondary" type="button" data-bs-dismiss="modal"
                title="{{t('general.button-cancel')}}">
                {{t('general.button-cancel')}}</button>
            </div>
            <div class="col-8 d-grid">
              <button
                (click)="this.updatePaymentMethods(this.paymentMethodsDetails[0],this.paymentMethodsDetails[1],'rename', this.auth.currentUserIDSig()?.uid, this.paymentMethodsModel.name);  this.triggerSpinner(true);"
                class="btn btn-sm btn-secondary rounded-pill" data-bs-dismiss="modal" type="button"
                title="{{t('general.button-update')}}"
                [ngClass]="{'disabled': paymentMethodsModel.name ===''}">{{t('general.button-update')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- DELETE MODAL -->
<div class="modal fade" id="deletionModal" tabindex="-1" aria-labelledby="deletionModalLabel" aria-hidden="true"
  *transloco="let t">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col text-end">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              title="{{t('general.button-close')}}"></button>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            <span class="material-symbols-outlined modal-icon-red align-content-center">
              delete
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col text-center">
            <strong>{{t('profile.remove-source')}}</strong>
            <br>
            <i>{{t('profile.irreversible')}}</i>
          </div>
        </div>
      </div>
      <div class="modal-footer px-0">
        <div class="container-fluid">
          <div class="row">
            <div class="col-4 d-grid">
              <button class="btn btn-sm btn-link btn-link-secondary" type="button" data-bs-dismiss="modal"
                title="{{t('general.button-cancel')}}">
                {{t('general.button-cancel')}}</button>
            </div>
            <div class="col-8 d-grid">
              <button
                (click)="this.updatePaymentMethods(this.paymentMethodsDetails[0],this.paymentMethodsDetails[1],'delete', this.auth.currentUserIDSig()?.uid); this.triggerSpinner(true);"
                class="btn btn-sm btn-secondary rounded-pill" data-bs-dismiss="modal" type="button"
                title="{{t('general.button-delete')}}">{{t('general.button-delete')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- UPDATE USER MODAL -->
<div class="modal fade" id="updateUserModal" tabindex="-1" aria-labelledby="updateUserModalLabel" aria-hidden="true"
  *transloco="let t">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col text-end">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              title="{{t('general.button-close')}}"></button>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            <span class="material-symbols-outlined modal-icon-grey align-content-center">
              draw
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col text-center">
            <form #UserDataForm="ngForm" class="base-font-color">
              <div class="card-text mb-4">
                <div class="row">
                  <div class="col ps-3 text-uppercase">
                    <b>{{t('profile.list-name')}}</b>
                  </div>
                </div>
                <div class="row">
                  <div class="col ps-3">
                    <input type="text" class="form-control" [(ngModel)]="UserDataModel.name" #name="ngModel" name="name"
                      placeholder={{this.db.currentUserDataSig()?.name}}>
                  </div>
                </div>
              </div>
              <div class="card-text mb-4">
                <div class="row">
                  <div class="col ps-3 text-uppercase">
                    <b>{{t('profile.list-surname')}}</b>
                  </div>
                </div>
                <div class="row">
                  <div class="col ps-3">
                    <input type="text" class="form-control" [(ngModel)]="UserDataModel.surname" #surname="ngModel"
                      name="surname" placeholder={{this.db.currentUserDataSig()?.surname}}>
                  </div>
                </div>
              </div>
              <div class="card-text mb-4">
                <div class="row">
                  <div class="col ps-3 text-uppercase">
                    <b>{{t('profile.list-username')}}</b>
                  </div>
                </div>
                <div class="row">
                  <div class="col ps-3">
                    <input type="text" class="form-control" [(ngModel)]="UserDataModel.username" #username="ngModel"
                      name="username" placeholder={{this.db.currentUserDataSig()?.username}}>
                  </div>
                </div>
              </div>
              <div class="card-text mb-4">
                <div class="row">
                  <div class="col ps-3 text-uppercase">
                    <b>{{t('profile.list-email')}}</b>
                  </div>
                </div>
                <div class="row">
                  <div class="col ps-3">
                    <strong>{{this.db.currentUserDataSig()?.email}}</strong>
                  </div>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
      <div class="modal-footer px-0">
        <div class="container-fluid">
          <div class="row">
            <div class="col-4 d-grid">
              <button class="btn btn-sm btn-link btn-link-secondary" type="button" data-bs-dismiss="modal"
                title="{{t('general.button-cancel')}}">
                {{t('general.button-cancel')}}</button>
            </div>
            <div class="col-8 d-grid">


              <button (click)="updateAccountDetails(UserDataModel)" class="btn btn-sm btn-secondary rounded-pill"
                [ngClass]="{'disabled': UserDataModel.name ==='' && UserDataModel.surname ==='' && UserDataModel.username ===''}"
                data-bs-dismiss="modal" type="button"
                title="{{t('general.button-update')}}">{{t('general.button-update')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- UPDATE ACCOUNT MODAL -->
<div class="modal fade" id="updateAccountModal" tabindex="-1" aria-labelledby="updateAccountModalLabel"
  aria-hidden="true" *transloco="let t">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col text-end">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              title="{{t('general.button-close')}}"></button>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            <span class="material-symbols-outlined modal-icon-grey align-content-center">
              draw
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col text-center">
            <form #UserDataForm="ngForm" class="base-font-color">
              <div class="card-text mb-4">
                <div class="row">
                  <div class="col ps-3 text-uppercase">
                    <b>{{t('profile.list-language')}}</b>
                  </div>
                </div>
                <div class="row">
                  <div class="col ps-3 mt-2">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="lang_pl" value="pl" name="lang"
                        [(ngModel)]="UserDataModel.lang">
                      <label class="form-check-label" for="lang_pl">Polski</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="lang_en" value="en" name="lang"
                        [(ngModel)]="UserDataModel.lang">
                      <label class="form-check-label" for="lang_en">English</label>
                    </div>
                    <div class="invalid-feedback">{{t('general.form-feedback')}}</div>
                  </div>
                </div>
              </div>
              <div class="card-text mb-4">
                <div class="row">
                  <div class="col ps-3 text-uppercase">
                    <b>{{t('profile.list-currency')}}</b>
                  </div>
                </div>
                <div class="row">
                  <div class="col ps-3 mt-2">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="curr_pln" value="PLN" name="currency"
                        [(ngModel)]="UserDataModel.currency">
                      <label class="form-check-label" for="curr_pln">PLN</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" id="curr_usd" value="USD" name="currency"
                        [(ngModel)]="UserDataModel.currency">
                      <label class="form-check-label" for="curr_usd">USD</label>
                    </div>
                    <div class="invalid-feedback">{{t('general.form-feedback')}}</div>
                  </div>
                </div>
              </div>
              <div class="card-text mb-4">
                <div class="row">
                  <div class="col ps-3 text-uppercase">
                    <b>{{t('profile.list-reg-date')}}</b>
                  </div>
                </div>
                <div class="row">
                  <div class="col ps-3 mt-2">
                    <strong>{{this.db.currentUserDataSig()?.regDate}}</strong>
                  </div>
                </div>
              </div>
              <div class="card-text mb-4">
                <div class="row">
                  <div class="col ps-3 text-uppercase">
                    <b>{{t('profile.list-plan')}}</b>
                  </div>
                </div>
                <div class="row">
                  <div class="col ps-3 mt-2">
                    <strong>{{this.db.currentUserDataSig()?.plan}}</strong>
                  </div>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
      <div class="modal-footer px-0">
        <div class="container-fluid">
          <div class="row">
            <div class="col-4 d-grid">
              <button class="btn btn-sm btn-link btn-link-secondary" type="button" data-bs-dismiss="modal"
                title="{{t('general.button-cancel')}}">
                {{t('general.button-cancel')}}</button>
            </div>
            <div class="col-8 d-grid">


              <button (click)="updateAccountDetails(UserDataModel)" class="btn btn-sm btn-secondary rounded-pill"
                [ngClass]="{'disabled': UserDataModel.lang ==='' && UserDataModel.currency ===''}"
                data-bs-dismiss="modal" type="button"
                title="{{t('general.button-update')}}">{{t('general.button-update')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>